// extracted by mini-css-extract-plugin
export var arrows = "_1z-5";
export var decrementer = "_1z-9";
export var disabled = "_1z-3";
export var error = "_1z-1";
export var hiddenText = "_1z-a";
export var incrementer = "_1z-8";
export var input = "_1z-7";
export var inputWrapper = "_1z-0";
export var leadingIcon = "_1z-b";
export var readonly = "_1z-2";
export var regular = "_1z-6";
export var small = "_1z-4";